export const lockDataResponse = {
  failures: [
    {
      vendorNo: 'V29130',
      invoiceId: 'INV1001',
      errorCode: 500,
      errorMsg: 'Internal Server Error'
    }
  ],
  successes: [
    {
      vendorNo: 'V29130',
      invoiceId: 'INV1002',
      lockStatus: 'Locked'
    },
    {
      vendorNo: 'V29130',
      invoiceId: 'INV1003',
      lockStatus: 'Locked'
    }
  ]
};
